/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import Utilities from '../../global/Utilities';
import { COMMON, ADD_KRISHAK_SCREEN } from '../../global/Constants';

class AddLocalImages extends Component {

    constructor(props) {
        super(props)

        this.state = {
            images: [],
            addImageVisible: true,
            selectedFiles: [],
            isUpdate: false,
        }
    }

    componentDidMount() {
        let images = this.props.selectedImages;
        let newImageArray = [];
        if (images) {
            //Utilities.LogPrint("images", images);
            images.forEach(element => {
                newImageArray.push({ image_url: URL.createObjectURL(element.file), name: element.name });
            });
            this.setState({
                images: newImageArray, selectedFiles: images
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps?.selectedImages !== this.props?.selectedImages) {
            if (!this.state.isUpdate) {
                const { selectedImages } = this.props;
                let newImageArray = [];
                if (selectedImages != null) {
                    Utilities.LogPrint("SelectedImages", selectedImages);

                    selectedImages.forEach(element => {
                        newImageArray.push({ path: window.URL.createObjectURL(element), name: element.name });
                    });

                    this.setState({ images: newImageArray, selectedFiles: selectedImages, isUpdate: true, addImageVisible: (selectedImages.length < 3) });
                }
            }
        }
    }

    // On file select (from the pop up)
    onFileChange = event => {
        const newArray = this.state.images.slice(); // Create a copy
        const files = this.state.selectedFiles.slice();

        if (newArray.length < 3) {
            if (event.target.files && event.target.files[0]) {
                let reader = new FileReader();
                reader.onload = (e) => {

                    let file = event.target.files[0];
                    newArray.push({
                        image_id: 0,
                        name: file.name,
                        mimeType: file.type,
                        size: file.size,
                        image_url: e.target.result,
                        file: file
                    });
                    files.push(event.target.files[0]);
                    this.setState({
                        images: newArray,
                        addImageVisible: (newArray.length < 3),
                        selectedFiles: files
                    }, () => {
                        this.props.handleAddImages(newArray, this.state.selectedFiles);
                    });
                    event.target.value = null;
                };
                reader.readAsDataURL(event.target.files[0]);
            }
        } else {
            alert("You can add maximum 3 Images");
        }
    };

    deleteImage = (item) => {

        var fileArray = [...this.state.selectedFiles];
        var fileIndex = fileArray.findIndex(Obj => Obj.name === item.name);

        var array = [...this.state.images]; // make a separate copy of the array
        var index = array.indexOf(item);

        if (index !== -1) {
            array.splice(index, 1);
            fileArray.splice(fileIndex, 1);

            this.setState({
                images: array,
                selectedFiles: fileArray,
                addImageVisible: (array.length < 3)
            }, () => {
                this.props.handleAddImages(this.state.images, this.state.selectedFiles);
            });
        }
    }


    render() {
        const { images, addImageVisible } = this.state;
        const { fromFeedBack } = this.props;

        const imageListItem = images.map((image, i) => {
            return (
                <div className={fromFeedBack ? "col-4 col-lg-3 image-info img-close-btn" : "col-lg-2 col-4 image-info img-close-btn"} key={i}>
                    <img src={image?.image_url} alt="" />
                    <a onClick={(e) => this.deleteImage(image)}><i className="customic ic-close"></i></a>
                </div>
            )
        });

        return (
            <div className="form-group">
                <label className={fromFeedBack ? "font-weight-medium" : "font-weight-medium mt-2"}>{COMMON.ADD_IMAGES} <span className="font-weight-normal">{fromFeedBack ? ADD_KRISHAK_SCREEN.IF_ANY : COMMON.MAX_3}</span></label>
                <div className="row row7-5">
                    {imageListItem}
                    <div className={addImageVisible ? fromFeedBack ? "col-4 col-lg-3" : "col-lg-2 col-4" : "d-none"}>
                        <div className="upload-img-box" >
                            <i className="customic ic-add"></i>
                            <input type="file" accept="image/*" onChange={this.onFileChange} />
                            <span className="uploaded-img d-none"></span>
                        </div>
                    </div>

                </div>

            </div>
        )
    }
}

export default AddLocalImages;
